import React, { useCallback, useRef, useEffect, useState } from 'react';

import { Container, Content, Background, AnimatedDiv2 } from './styles';

import PosterComponent from '../../components/PosterComponent';
import { useSocket } from '../../hooks/Socket';
import { useAuth } from '../../hooks/Auth';

interface PosterData {
  email: string;
  password: string;
  name: string;
}

const Poster: React.FC = () => {
  const { socket } = useSocket();
  const {user} = useAuth();

  useEffect(() => {
    const ping = setInterval(() => {
      socket?.emit('SetAttendance', {
        room: 87,
      });
    }, 120000);

    return () => clearInterval(ping);
  }, []);

  useEffect(() => {
    socket?.emit('SetAttendance', {
      room: 87,
    });
  }, []);


  if(!user){

    window.location.href = '/app/36-simposio-de-oftalmologia-do-hcpa/login-poster'

  }

  return (
    <Container>
      <PosterComponent />
    </Container>
  );
};
export default Poster;
